import { List } from '@opengov/compose-app/immutable';

import { localeMiddleware } from './locale/loader';

export const middleware = List([localeMiddleware]);
